import React from 'react'
import * as styles from '../styles/templates/content-page.module.scss'
import { HeadFC, PageProps } from 'gatsby'
import ContentPageLayout from '../layouts/content-page'
import ContentBlockZone from '../components/content-blocks/content-block-zone'
import { SEO } from '../components/seo'
import Body from '../components/body'
import { PageContext } from './shared'
import { renderRichText } from 'gatsby-source-storyblok'
import LinkBlock from '../components/content-blocks/link'
import { StoryBlokNestedBlok } from '../utils/storyblok'

const renderCmsBloks = (bloks?: StoryBlokNestedBlok[] | string) => {
    if (!bloks) {
        return []
    }

    if (typeof bloks === 'string') {
        return [
            <div dangerouslySetInnerHTML={{ __html: renderRichText(bloks) }} />,
        ]
    }

    return bloks.map((blok, i) => {
        const key = `blok-${i}`
        if (blok?.component === 'plain-text') {
            return <div key={key} dangerouslySetInnerHTML={{ __html: renderRichText(blok.text) }} />
        }
        if (blok?.component === 'link') {
            return <LinkBlock label={blok.label} href={blok.url} internalLink={false} />
        }
    })
}

const ContentPageTemplate: React.FC<PageProps<object, PageContext>>  = ({ pageContext }) => {
    const { contentBlocks, title, label, headerImage, headerImageSecondary, body } = pageContext
    const headerImg = headerImage?.includes('storyblok') ? `${headerImage}/m/2000x0` : headerImage
    const renderedCmsContent = renderCmsBloks(body)

    return (
        <ContentPageLayout
            title={title}
            label={label}
            headerImage={headerImg}
            headerImageSecondary={headerImageSecondary}
        >
            {!!renderedCmsContent.length &&
                <Body className={styles.renderedBody}>
                    {renderedCmsContent}
                </Body>
            }
            {contentBlocks && <ContentBlockZone blocks={contentBlocks} />}
        </ContentPageLayout>
    )
}

export const Head: HeadFC<PageProps, PageContext> = ({ pageContext }) => {
    const { name, description, headerImage, _path } = pageContext
    const seoImg = headerImage?.includes('storyblok') ? `${headerImage}/m/1200x630` : headerImage

    return (
        <SEO
            title={`${name} | Koherent`}
            path={_path}
            description={description}
            imageUrl={seoImg}
        />
    )
}

export default ContentPageTemplate
